module.exports = __webpack_public_path__ + "img/happy-woman.280e73a6.svg";